import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_2 = { id: "obtainLicense" }

import { Component, onMounted, PropType, Ref, ref, shallowRef, getCurrentInstance } from 'vue';
import { Backend, Failure, setBaseUrl } from './modules/backend';
import { returnToActivity, returnToSystemHomepage } from './modules/frontend'
import Loading from "./components/Loading.vue"
import NotFound from "./components/NotFound.vue"
import TooEarly from './components/TooEarly.vue';
import UnknownError from './components/UnknownError.vue';
import AlreadyPaid from './components/AlreadyPaid.vue';
import PaymentOptions from './components/PaymentOptions.vue';
import Success from './components/Success.vue';



export default _defineComponent({
  expose: [],
  props: {
	baseUrl: {
		type: String,
		required: true
	},
	tenantId: {
		type: String,
		required: true
	},
	classId: {
		required: true,
		type: null as unknown as PropType<number | null>,
		validator: (v: any) => typeof v === 'number' || v === null,
	},
	studentGid: {
		type: String,
		required: true
	},
	tenantName: {
		type: String,
		required: true
	},
	tenantPaymentUrl: {
		type: String,
		required: false
	},
	tenantRedemptionUrl: {
		type: String,
		required: false
	},
	ltiIdToken: {
		type: String,
		required: false
	},
	ltiState: {
		type: String,
		required: false
	},
	className: {
		type: String,
		required: true
	},
	fullName: {
		type: String,
		required: true
	},
	userEmail: {
		type: String,
		required: true
	},
	timezone: {
		type: String,
		required: true
	},
	privateLabels: {
		type: Object,
		required: true
		/*
		Expected fields:
			logoUrl
			productName
			supportEmail
			companyAboutLink
			studentHelpLink
			privacyPolicyLink
			companyName
			companyAddress
		*/
	},
	// This prop is used to determine whether class id sent by mobius can be trusted;
	// If true it indicates newer mobius version with classId fixes.
	classIdTrusted: {
		type: Boolean,
		required: false
	}
},
  setup(__props) {

const props = __props



setBaseUrl(props.baseUrl)

/**
 * TODO: change "classId: props.classIdTrusted ? props.classId : null" to "classId: props.classId"
 * We use classIdTrusted property in order to determine
 * whether class id sent by mobius can be trusted.
 * If true it indicates newer mobius version with classId fixes,
 * otherwise we set classId to null because of an issue with using class links.
 * See https://digitaled.atlassian.net/browse/MO-10043 for more details.
 */
const contentAndStudent = {
	contentId: {
		tenantId: props.tenantId,
		classId: props.classIdTrusted ? props.classId : null,
	},
	studentGid: props.studentGid,
}

const tenant = {
	id: props.tenantId,
	name: "",
	paymentUrl: "",
	redemptionUrl: "",
}

const commonProps = {className: props.className}

const currentScreen: Ref<Component> = shallowRef(Loading)
const screenProps: Ref<Object> = ref(commonProps)

function navigate(screen: object, childProps: object = commonProps) {
	screenProps.value = childProps
	currentScreen.value = screen
}

async function showInitialScreen() {

	try {
		const result = await Backend.fetchContentAvailability(contentAndStudent)
		const found = await Backend.getTenant(tenant)

		if (result instanceof Failure) {

			switch (result.err) {
			case "NotFound":
				navigate(NotFound)
				break
			default:
				navigate(UnknownError)
			}

		} else {

			if (result.studentTransactions.alreadyPaid) navigate(AlreadyPaid)
			else if (!result.withinPurchasePeriod) {
				navigate(TooEarly, {
					className: props.className,
					purchaseOpens: result.purchasePeriodStart,
				})
			} else {
				navigate(PaymentOptions, {
					className: props.className,
					contentAndStudent,
					availability: result,
					studentInfo: {
						name: props.fullName,
						emailAddress: props.userEmail,
					},
					privateLabels: props.privateLabels,
					tenantName: props.tenantName,
					tenantPaymentUrl: found instanceof Failure ? "" : found.paymentUrl ? found.paymentUrl : "",
					tenantRedemptionUrl: found instanceof Failure ? "" : found.redemptionUrl ? found.redemptionUrl : "",
					ltiIdToken: props.ltiIdToken ? props.ltiIdToken : "",
					ltiState: props.ltiState ? props.ltiState : "",
					emailValues: {
						studentEmailAddress: props.userEmail,
						studentName: props.fullName,
						tenantName: props.tenantName,
						className: props.className,
						logoUrl: props.privateLabels.logoUrl,
						productName: props.privateLabels.productName,
						supportEmailAddress: props.privateLabels.supportEmail,
						companyAboutLink: props.privateLabels.companyAboutLink,
						studentHelpLink: props.privateLabels.studentHelpLink,
						privacyPolicyLink: props.privateLabels.privacyPolicyLink,
						companyName: props.privateLabels.companyName,
						companyAddress: props.privateLabels.companyAddress
					},
				})
			}
		}

	} catch (e: unknown) {
		navigate(UnknownError)
	}

}

onMounted(showInitialScreen)

function licenseObtained() {
	screenProps.value = commonProps
	navigate(Success)
}


function returnToMobius() {
	if (props.className == props.tenantName) {
		// User most likely came from their profile, return to system homepage.
		// Their licenses will not be refreshed until the next time they log in.
		returnToSystemHomepage()
	} else {
		// User is most likely in a class, let mobius redirect them appropriately.
		// Their licenses will be refreshed immediately.
		returnToActivity()
	}
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(currentScreen)), _mergeProps(screenProps.value, {
        onSuccess: licenseObtained,
        onError: _cache[1] || (_cache[1] = ($event: any) => (navigate(UnknownError))),
        onReturnToMobius: returnToMobius,
        onStartOver: showInitialScreen
      }), null, 16))
    ])
  ], 64))
}
}

})